


































// import { User } from '@/api/com/MetaPattern/APP/MDA/User/User';
// import { UserService } from '@/api/com/MetaPattern/APP/MDA/User/UserService';
// import { AccountService } from '@/api/com/MetaPattern/Core/Base/Account/AccountService';
// import { LoginAccount } from '@/api/com/MetaPattern/Core/Base/Account/LoginAccount';
// import { LoginAccountService } from '@/api/com/MetaPattern/Core/Base/Account/LoginAccountService';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class Footer extends Vue {
  getDigramIsModified() {
    return this.$store.state.ModuleMD.curDiagram?.isModified;
  }

  getDigramIsNew() {
    return this.$store.state.ModuleMD.curDiagram?.isNew;
  }

  getElementName() {
    return this.$store.state.ModuleMD.curMDElement?.Name;
  }

  test() {
    // console.log('test');
    // const user = new User();
    // user.nickname = 'testNickname';
    // user.loginAccountId = '1613424072748220416';
    // console.log(user);
    // UserService.CreateAsync(user).then((response: User) => console.log(response));
    // UserService.DeleteAsync('2022103014083200001').then((response: boolean) => console.log(response));
    // LoginAccountService.LoadByIdAsync('')
    //   .then(response => {
    //     console.log('response');
    //     console.log(response);
    //   })
    //   .catch((err) => {
    //     console.log('error');
    //     console.log(err);
    //   });
  }
}
